<template>
  <div class="conteudoTable">
            <p  class="txtDadosG">Totais</p>
             <p  class="txtDadosG" align="left"> ICMS</p>
              <div class="dadosGerais" style="display:block;">
                   <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total do FCP retido anteriormente por ST</label><br>
                        <input type="text" v-model="table.icms.fcpRetidoST" readonly>
                    </div>
                <div style="display:flex; justify-content: space-between;">
                <div style="flex-direction:column; width:24.5%;">
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Base de Cálculo ICMS</label><br>
                        <input type="text"  v-model="table.icms.baseCalculo" readonly>
                    </div>
                     <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total ICMS FCP</label><br>
                        <input type="text"  v-model="table.icms.icmsfcp" readonly>
                    </div>
                     <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor ICMS Substituição</label><br>
                        <input type="text"  v-model="table.icms.icmsSubstituicao" readonly>
                    </div>
                     <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor do Frete</label><br>
                        <input type="text"  v-model="table.icms.frete" readonly>
                    </div>
                     <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total do IPI</label><br>
                        <input type="text"   readonly>
                    </div>
                     <div style="width:100%;margin-top:7px"> 
                        <label for="">Outras Despesas Acessórias</label><br>
                        <input type="text"  v-model="table.icms.outrasDespesas" readonly>
                    </div>
                </div>
                <div style="flex-direction:column;width:24.5%;">
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor do ICMS</label><br>
                        <input type="text"  v-model="table.icms.icms" readonly>
                    </div>
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total ICMS Interestadual UF Destino</label><br>
                        <input type="text"  readonly>
                    </div>
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total do FCP retido por ST</label><br>
                        <input type="text" v-model="table.icms.fcpRetidoST" readonly>
                    </div>
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor do Seguro</label><br>
                        <input type="text" v-model="table.icms.seguro" readonly>
                    </div>
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total do IPI Devolvido</label><br>
                        <input type="text" v-model="table.icms.ipiDevolvido" readonly>
                    </div>
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total da NFe</label><br>
                        <input type="text" v-model="table.icms.totalNFe" readonly >
                    </div>
                </div>
                <div style="flex-direction:column; width:24.5%;">
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor do ICMS Desonerado</label><br>
                        <input type="text"  v-model="table.icms.icmsDesonerado" readonly>
                    </div>
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total do ICMS Interestadual UF Rem.</label><br>
                        <input type="text"  v-model="table.icms.icmsUfRemetente" readonly>
                    </div>
                   
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total dos Descontos</label><br>
                        <input type="text"   readonly>
                    </div>
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor do PIS</label><br>
                        <input type="text"  v-model="table.icms.pis" readonly>
                    </div>
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Aproximado dos Tributos</label><br>
                        <input type="text" readonly >
                    </div>                   
                </div>
                <div style="flex-direction:column;width:24.5%;">
                    <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total do FCP</label><br>
                        <input type="text" v-model="table.icms.fcpTotal" readonly >
                    </div>
                     <div style="width:100%;margin-top:7px"> 
                        <label for="">Base de Cálculo ICMS ST</label><br>
                        <input type="text" v-model="table.icms.baseCalculoST" readonly >
                    </div>
                     <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total dos Prdoutos</label><br>
                        <input type="text" v-model="table.icms.totalProdutos" readonly >
                    </div>
                     <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor Total do II</label><br>
                        <input type="text" v-model="table.icms.totalII" readonly >
                    </div>
                     <div style="width:100%;margin-top:7px"> 
                        <label for="">Valor do COFINS</label><br>
                        <input type="text" v-model="table.icms.cofins" readonly >
                    </div>
                </div>
                </div>
                
            </div>
  </div>
</template>

<script>
export default {
    props:['table'],
    data(){
        return{
            
        }
    },
    

}
</script>

<style>

</style>